import { WIZARD_DEFINITION as WIZARD_DEFINITION_TERMINAL,
} from 'src/productconfig/customer/hochwald/terminal-wizard-definition.config';

import { WIZARD_DEFINITION as WIZARD_DEFINITION_TERMINAL_1,
} from 'src/productconfig/customer/hochwald/terminal-1-wizard-definition.config';

import { WIZARD_DEFINITION as WIZARD_DEFINITION_TERMINAL_2,
} from 'src/productconfig/customer/hochwald/terminal-2-wizard-definition.config';

import { WIZARD_DEFINITION as WIZARD_DEFINITION_ONLINE_TERMINAL,
} from 'src/productconfig/customer/hochwald/onlineterminal-wizard-definition.config';

import {WIDGET_DEFINITION as YARD_WIDGET_DEFINITION,
  WIZARD_DEFINITION as YARD_WIZARD_DEFINITION,
  WIZARD_STEP_CONTROLLER as YARD_WIZARD_STEP_CONTROLLER,
  TmcYardProductModule
} from 'src/tmc-yard/tmc-yard.product';

import {WIDGET_DEFINITION as VISITORS_WIDGET_DEFINITION,
  WIZARD_DEFINITION as VISITORS_WIZARD_DEFINITION,
  WIZARD_STEP_CONTROLLER as VISITORS_WIZARD_STEP_CONTROLLER,
  TmcVisitModule} from 'src/tmc-visit/tmc-visit.product';

import {WIDGET_DEFINITION as TMC_COMMON_WIDGET_DEFINITION,
  WIZARD_DEFINITION as TMC_COMMON_WIZARD_DEFINITION,
  WIZARD_STEP_CONTROLLER as TMC_COMMON_WIZARD_STEP_CONTROLLER,
  TmcCommonModule} from 'src/tmc-common/tmc-common.product';

import { TransportFurtherInfoModule } from 'src/productconfig/customer/hochwald/widgets/transport-further-info/transport-further-info.module';
import { TransportFurtherInfoComponent } from 'src/productconfig/customer/hochwald/widgets/transport-further-info/transport-further-info.component';


export const MODULES = [
TmcYardProductModule,
TmcCommonModule, TmcVisitModule,
TransportFurtherInfoModule];

export const WIDGET_DEFINITION = [
...TMC_COMMON_WIDGET_DEFINITION,
...YARD_WIDGET_DEFINITION,
...VISITORS_WIDGET_DEFINITION,
{ key: 'transportFurtherInfoWidget', name: 'Transport: Wie geht es weiter', description: 'TBD', icon: 'fa-light fa-display-arrow-down', groupIdentifier: 'terminal', widgetComponent: TransportFurtherInfoComponent, editorComponent: null, autoreload: false }
];

export const WIZARD_STEP_CONTROLLER = [
...TMC_COMMON_WIZARD_STEP_CONTROLLER,
...VISITORS_WIZARD_STEP_CONTROLLER,
...YARD_WIZARD_STEP_CONTROLLER];

export const WIZARD_DEFINITION = [
...TMC_COMMON_WIZARD_DEFINITION,
...VISITORS_WIZARD_DEFINITION,
...YARD_WIZARD_DEFINITION,
WIZARD_DEFINITION_TERMINAL,
WIZARD_DEFINITION_TERMINAL_1,
WIZARD_DEFINITION_TERMINAL_2,
WIZARD_DEFINITION_ONLINE_TERMINAL];
